import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthState, authFeatureKey } from './auth.reducer';

export const authStateSelector =
  createFeatureSelector<AuthState>(authFeatureKey);

export const selectAuthState = createSelector(
  authStateSelector,
  (state) => state
);

export const selectAuthenticationStatus = createSelector(
  authStateSelector,
  (state) => state.authenticateRequestStatus
);

/**
 * Whether a patient is signed in RIGHT NOW. True from
 * `authenticateSuccess`/`updateLoginInfoSuccess` (the latter dispatched in the
 * same breath as `loadLoggedInPatient`, so it also covers a session restore on
 * refresh) and false again from `logOut` — the first action of a sign-out, ahead
 * of the logout API round-trip, so it holds on the failure path too.
 */
export const selectAuthLoggedIn = createSelector(
  authStateSelector,
  (state) => state.loggedIn
);
